export default __webpack_public_path__ + "media/images/brighteon-social/Icon-Messages-Gray-acd3f30163388e807382732e8ac9fb75.svg";